// Constants used only by WaveformLayout.

// Icon circle: medium loader at 48px with a 6px stroke (Meridian default is 32px / 4px).
export const WAVEFORM_ICON_TOKENS = { loaderTrackCircularMediumSize: 48, loaderTrackCircularMediumStrokeWidth: 6 };

// Content column: 64px indent + 238px text, so copy wraps like the design.
export const CONTENT_MAX_WIDTH = "302px";
